<template>
    <div class="notification">
        {{ message }}
    </div>
</template>
<script>
export default {
    props:{
        message:{
            type: String,
            required: true
        }
    }
}
</script>
<style scoped>
    .notification{
        background: var(--gradient);

        margin-top: 1rem;
        margin-bottom:1rem;
        padding:0.4em;
        border-radius:6px;
        font-family: var(--body-font);
        font-size:0.8rem;
        text-align:center;
        color:white;
    }
</style>